import React from 'react'
import { TIER_LABEL } from './stageProgress'

const MARK = {
  0: 'M16 28 L24 18 L16 10 L8 18 Z',
  1: 'M16 26 C16 26 8 20 8 14 C8 10 12 8 16 12 C20 8 24 10 24 14 C24 20 16 26 16 26 Z',
  2: 'M16 8 L18.5 13.5 L24 14.2 L20 18.2 L21 24 L16 21.2 L11 24 L12 18.2 L8 14.2 L13.5 13.5 Z',
  3: 'M16 7 L18 14 L25 16 L18 18 L16 25 L14 18 L7 16 L14 14 Z',
}

export default function StageBadge({
  summary,
  theme = 0,
  style,
  celebrate = false,
  unitLabel = '阶段',
}) {
  if (!summary) return null
  const earned = summary.earned
  const tierName = TIER_LABEL[summary.tier] || '未获得'
  const label = earned
    ? `${unitLabel}徽章：已获得，${tierName}，平均 ${summary.avgText} 分`
    : `${unitLabel}徽章：未获得，还差 ${summary.remaining} 关`

  return (
    <div
      className={`quest-stage-medal theme-${theme} tier-${summary.tier}${earned ? ' is-earned' : ''}${celebrate ? ' is-fresh' : ''}`}
      style={style}
      role="img"
      aria-label={label}
      title={label}
    >
      <svg viewBox="0 0 32 32" className="quest-stage-medal-shape" aria-hidden="true">
        <path className="quest-stage-medal-shield" d="M16 2 L28 7 V16 C28 23 22 28 16 30 C10 28 4 23 4 16 V7 Z" />
        {!earned ? <path className="quest-stage-medal-lock" d="M12 15 V12 a4 4 0 0 1 8 0 V15 M11 15 H21 V22 H11 Z" /> : (
          <path className="quest-stage-medal-mark" d={MARK[theme] || MARK[0]} />
        )}
      </svg>
    </div>
  )
}
